import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
const updated = require('./routesList.json');


Vue.use(Router)
var theroutes = [
  {
    path: '/helloworld',
    name: 'HelloWorld',
    component: HelloWorld
  },
  {
    path: '/',
    name: 'home',
    // redirect: '/home',
    component: () => import('@/views/home/index'),
    meta: {
      title: 'Build the future of your business with meShare today | meShare IoT',
      keywords: 'meshare',
      content: 'Video-streaming and IoT technologies are transforming our world. meShare\'s platform takes your business into the future, offering products to help you launch, manage, and grow video-streaming and IoT solutions.'
    }
  },
  {
    path: '/why',
    name: 'why',
    component: () => import('@/views/why/index'),
    meta: {
      title: 'Why meShare? | meShare IoT',
      keywords: '',
      content: 'meShare provides and connects smart devices of video and other home appliances to provide a variety of smart video and home automation applications.'
    }
  },
  {
    path: '/enterprise',
    name: 'enterprise',
    component: () => import('@/views/enterprise/index'),
    meta: {
      title: 'enterprise',
      keywords: '',
      content: 'enterprise'
    }
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('@/views/pricing/index'),
    meta: {
      title: 'Pricing - Low Cost and Highly Flexible Plans | meShare IoT',
      keywords: '',
      content: 'meShare provides and connects smart devices of video and other home appliances to provide a variety of smart video and home automation applications.'
    }
  },
  {
    path: '/career',
    name: 'career',
    component: () => import('@/views/career/index'),
    meta: {
      title: 'meShare Careers | meShare IoT',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/press',
    name: 'press',
    component: () => import('@/views/press/index'),
    meta: {
      title: 'News and Announcements | meShare IoT',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/press/:id',
    name: 'aticle',
    component: () => import('@/views/press/aticle.vue'),
    meta: {
      title: 'aticle',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/support',
    name: 'support',
    component: () => import('@/views/support/index'),
    meta: {
      title: 'support',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/supports',
    name: 'supports',
    component: () => import('@/views/support/index'),
    meta: {
      title: 'support',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/contact-us',
    name: 'contactUs',
    component: () => import('@/views/contactUs/index'),
    meta: {
      title: 'Contact us',
      keywords: 'meshare contact us',
      content: 'Thank you for your interest in meShare! Please fill out the form below to let us contact you soon. Or you can contact us directly via below ways.'
    }
  },
  {
    path: '/cvr-service',
    name: 'cvrService',
    component: () => import('@/views/products/cvr-service.vue'),
    meta: {
      title: 'Cloud Video Recording',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/alerts-service',
    name: 'alertService',
    component: () => import('@/views/products/alerts-service.vue'),
    meta: {
      title: 'Real-Time Alerts',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/customer-service',
    name: 'customerService',
    component: () => import('@/views/products/customer-service.vue'),
    meta: {
      title: 'Customer Services',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/detection-service',
    name: 'detectionService',
    component: () => import('@/views/products/detection-service.vue'),
    meta: {
      title: 'AI-Object Detection',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/introduces',
    name: 'introduces',
    component: () => import('@/views/products/introduces.vue'),
    meta: {
      title: 'APP Development',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/live-video-service',
    name: 'liveVideoService',
    component: () => import('@/views/products/live-video-service.vue'),
    meta: {
      title: 'Live Video Streaming',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/mroms-service',
    name: 'mromsService',
    component: () => import('@/views/products/mroms-service.vue'),
    meta: {
      title: 'Resource Management',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/notice-service',
    name: 'noticeService',
    component: () => import('@/views/products/notice-service.vue'),
    meta: {
      title: 'In-APP Advertising',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/iot-platform',
    name: 'iot-platform',
    component: () => import('@/views/products/iot-platform.vue'),
    meta: {
      title: 'Internet of Things Platform | meShare IoT',
      keywords: '',
      content: 'Launch your IoT solution with the platform that has already connected and served over 2.5 million users, 8 million devices and counting.'
    }
  },
  {
    path: '/cloud-video-recording-streaming',
    name: 'cloud-video-recording-streaming',
    component: () => import('@/views/products/cloud-video-recording-streaming.vue'),
    meta: {
      title: 'Cloud Video Recording and Streaming | meShare IoT',
      keywords: '',
      content: 'Cloud Video Recording & Streaming'
    }
  },
  {
    path: '/web-and-mobile-app',
    name: 'web-and-mobile-app',
    component: () => import('@/views/products/web-and-mobile-app'),
    meta: {
      title: 'Customizable Web & Mobile Apps | meShare IoT',
      keywords: '',
      content: 'Launch with fully-featured, market-tested mobile and web applications, customized to fit your brand and solutions.'
    }
  },
  {
    path: '/analytics-and-growth',
    name: 'analytics-and-growth',
    component: () => import('@/views/products/analytics-and-growth.vue'),
    meta: {
      title: 'Business Analytics and Intelligence Tools | meShare IoT',
      keywords: '',
      content: 'Monitor, track, and manage your users, devices, and services to improve your user experience, optimize your marketing, and grow your business.'
    }
  },
  {
    path: '/services',
    name: 'services',
    component: () => import('@/views/products/services.vue'),
    meta: {
      title: 'Support, Manufacturing and Marketing Services | meShare IoT',
      keywords: '',
      content: 'Utilize end-to-end services from experts in the field to help you launch and grow your business.'
    }
  },
  {
    path: '/smart-home-and-iot',
    name: 'smart-home-and-iot',
    component: () => import('@/views/solutions/smart-home-and-iot.vue'),
    meta: {
      title: 'Build Smart Home Solutions | meShare IoT',
      keywords: '',
      content: 'meShare\'s platform offers solutions for a wide and growing array of IoT applications. meShare is the one-stop-shop with products to help from ideation, through launch, to post-launch and growth.'
    }
  },
  {
    path: '/security-and-surveillance',
    name: 'security-and-surveillance',
    component: () => import('@/views/solutions/security-and-surveillance.vue'),
    meta: {
      title: 'Build Security and Surveillance Solutions | meShare IoT',
      keywords: '',
      content: 'meShare\'s platform offers solutions for a wide and growing array of IoT applications. meShare is the one-stop-shop with products to help from ideation, through launch, to post-launch and growth.'
    }
  },
  {
    path: '/property-management-and-real-estate',
    name: 'property-management-and-real-estate',
    component: () => import('@/views/solutions/property-management-and-real-estate.vue'),
    meta: {
      title: 'Build Property Management and Real Estate Solutions | meShare IoT',
      keywords: '',
      content: 'meShare\'s platform allows you to bring video-streaming and IoT to transform the value of and the way your customers see and experience your properties. '
    }
  },
  {
    path: '/open-source-agreement',
    name: 'open-source-agreement',
    component: () => import('@/views/policies/open-source-agreement.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/privacy-notice',
    name: 'privacy-notice',
    component: () => import('@/views/policies/privacy-notice.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/policies/privacy-notice.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/return-policy',
    name: 'return-policy',
    component: () => import('@/views/policies/return-policy.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/sales-terms',
    name: 'sales-terms',
    component: () => import('@/views/policies/sales-terms.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/software-end-user-license-agreement',
    name: 'software-end-user-license-agreement',
    component: () => import('@/views/policies/software-end-user-license-agreement.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/terms-of-services',
    name: 'terms-of-services',
    component: () => import('@/views/policies/terms-of-services.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/warranty',
    name: 'warranty',
    component: () => import('@/views/policies/warranty.vue'),
    meta: {
      title: 'policy',
      keywords: '',
      content: ''
    }
  },
  {
    path: '/get-the-app',
    name: 'get-the-app',
    component: () => import('@/views/get-the-app/index.vue'),
    meta: {
      title: 'Get the App',
      keywords: '',
      content: ''
    }
  }
];

//SEO changing the title and meta tag from routesList.json
for(var i=0; i<theroutes.length; i++){
  var path = theroutes[i].path;
 
  if (updated[path]!= undefined && updated[path]['title']!=null ){
    theroutes[i].meta.title = updated[path]['title'];
  }

  if (updated[path]!= undefined && updated[path]['meta']!=null ){
    theroutes[i].meta.content = updated[path]['meta'];
  }

} 
//Finished SEO

export default new Router({
  mode: 'history',
  routes: theroutes
})



// WEBPACK FOOTER //
// ./src/router/index.js